export default __webpack_public_path__ + "static/media/background-login.02f96912.svg";